import { Divider } from "antd"
import { Footer } from "antd/es/layout/layout"

function AppFooter(): JSX.Element {
  return (
    <>
      <Divider className="footer-divider" />
      <Footer className="footer-content text-center">
        ©{new Date().getFullYear()} - InsureFlow - by <a className="by-satoripop" href="https://satoripop.com" target="_blank">satoripop</a>
      </Footer>
    </>
  )
}

export default AppFooter
